const NotFoundPage = () => {
    return ('404');
};

export default NotFoundPage;